import { Iframely } from 'piconetworks/pkg-module-iframely'

import createDuck from '../baseDuck'

export default Iframely({
    createDuck,
})
